export default "__VITE_ASSET__B8Zka1jd__"